import React from 'react';
import PropTypes from 'prop-types';

import intlShape from '@/shared/utils/intlShape';
import DataCacheService from '@/shared/services/DataCacheService';
import FormattedDateTime from '../../shared/components/FormattedDateTime';
import FormattedListValue, { listItemMsg } from '../../shared/components/FormattedListValue';
import { injectStateService, StateService } from '../../shared/services/StateService';
import messages from './jobMessages';
import RelationName from '@/shared/components/RelationName';
import { DeleteIcon } from '@/shared/components/Icons';

const SyncOverviewRow = ({
  item,
  intl,
  stateService,
  onOpenRegistrationModal,
  onDelete,
  relation,
}) => {
  const user = DataCacheService.getUserName(item.createdBy);

  const parseErrorMessage = error => {
    if (!error) return;
    let errorObject;
    try {
      errorObject = JSON.parse(error);
    } catch {
      return error.length > 500 ? `${error.substring(0, 500)}...` : error;
    }
    const parameters = {};
    if (errorObject.parameters && errorObject.parameters.length > 0) {
      for (let i = 0; i < errorObject.parameters.length; i++) {
        parameters[`p${i}`] = errorObject.parametersEnumType // if the parameters are of a specific enum type, we will translate it accordingly.
          ? Array.isArray(errorObject.parameters[i])
            ? errorObject.parameters[i]
                .map(x => intl.formatMessage(listItemMsg(errorObject.parametersEnumType, x)))
                .join(', ')
            : intl.formatMessage(
                listItemMsg(errorObject.parametersEnumType, errorObject.parameters[i]),
              )
          : errorObject.parameters[i] // try to translate parameter in case its translatable
          ? intl.formatMessage({
              id: errorObject.parameters[i],
              defaultMessage: errorObject.parameters[i],
            })
          : '';
      }
    }
    return <FormattedListValue list={errorObject.type} id={errorObject.code} values={parameters} />;
  };

  const renderEntity = syncItem => {
    if (syncItem.entityId) {
      switch (syncItem.entityType) {
        case 0:
          return (
            <span className="clickable" onClick={() => onOpenRegistrationModal(syncItem)}>
              <span style={{ verticalAlign: 'middle' }}>
                <i className="fa fa-external-link" />
              </span>
              &nbsp; {intl.formatMessage(messages.Registration)}
            </span>
          );
        case 1:
          return (
            <span
              className="clickable"
              onClick={() => stateService.gotoRelation(syncItem.entityId)}
            >
              <span style={{ verticalAlign: 'middle' }}>
                <i className="fa fa-external-link" />
              </span>
              &nbsp; {intl.formatMessage(messages.Relation)}
            </span>
          );
        case 2:
          return (
            <span
              className="clickable"
              onClick={() => stateService.gotoDocument({ documentId: syncItem.entityId })}
            >
              <span style={{ verticalAlign: 'middle' }}>
                <i className="fa fa-external-link" />
              </span>
              &nbsp; {intl.formatMessage(messages.Document)}
            </span>
          );

        // Default case for unknown entity types
        default:
          break;
      }
    }
    return '-';
  };

  return (
    <tbody className="hover">
      <tr>
        <td>{item.connectPlatformDisplayValue}</td>
        <td>
          <FormattedListValue list="syncType" id={item.syncType} />
        </td>
        <td>{user}</td>
        <td>
          <FormattedDateTime value={item.createdAt} />
        </td>
        <td>{renderEntity(item)}</td>
        <td>
          <RelationName relation={relation} />{' '}
        </td>
        <td>{parseErrorMessage(item.errorObjectJson)}</td>
        <td>
          <DeleteIcon
            className="clickable"
            onClick={() => onDelete(item)}
            tooltip={intl.formatMessage(messages.DeleteSyncResult)}
          />
        </td>
      </tr>
    </tbody>
  );
};

SyncOverviewRow.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    createdBy: PropTypes.string,
    connectPlatformDisplayValue: PropTypes.string,
    entityId: PropTypes.string,
    entityType: PropTypes.number,
    connectPlatform: PropTypes.number,
    syncType: PropTypes.number,
    errorObjectJson: PropTypes.string,
    relationId: PropTypes.string,
  }).isRequired,
  stateService: PropTypes.instanceOf(StateService).isRequired,
  intl: intlShape.isRequired,
  onOpenRegistrationModal: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  relation: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
};

export default injectStateService(SyncOverviewRow);
